import axios from "axios"
import appConfig from "@/config"
import useGlobalConfigStore from "@/stores/globalConfig"

export default (params?: any) => {
  return new Promise((resolve, reject) => {
    const setLoading = useGlobalConfigStore.getState().setLoading
    setLoading(true)
    const data: any = {
      prefix: "mynoark",
      // prefix: appConfig.prefix,
      type: params.type,
      deviceId: params.deviceId ? params.deviceId : [],
      identifier: params.identifier ? params.identifier : [],
      token: "hadkjlvnouq8293015hf0d9sh",
    }
    if (params.state !== undefined) {
      data.state = params.state
    }
    const url = `${appConfig.hBaseUrl}log/getDeviceEvents?start=${params.start}&end=${params.end}`
    axios.post(url, data).then((res) => {
      if (res.data.code == 200) {
        res.data.data.forEach((item: any) => {
          if (item.detail) {
            item.detail = JSON.parse(item.detail)
            if (item.type === "alarm" && item.detail.msg) {
              if (item.detail.msg.includes("Fault") || item.detail.msg.includes("fault")) {
                item.type = "fault"
              } else {
                item.type = "warning"
              }
            }
          }
        })
        setLoading(false)
        resolve(res.data)
      } else {
        setLoading(false)
        reject(res)
      }
    })
  })
}
